export const LOCATION_CLICK = "ENTITY_LOCATION_CLICK";
export const SET_ACTIVE_LOCATION = "ENTITY_SET_ACTIVE_LOCATION";
export const LOCATION_SWIPE_RIGHT = "ENTITY_LOCATION_SWIPE_RIGHT";
export const LOCATION_SWIPE_LEFT = "ENTITY_LOCATION_SWIPE_LEFT";
export const LOCATION_DETAIL_SWIPE_UP = "ENTITY_LOCATION_DETAIL_SWIPE_UP";
export const TOGGLE_MAP_VIEW = "ENTITY_TOGGLE_MAP_VIEW";
export const CLOSE_ZOOM = "ENTITY_CLOSE_ZOOM";
